import React, {Component} from 'react';
import { TagFilter } from 'searchkit';
import { ToggleBox } from './styles/ToggleBox';
import { ToggleLabel } from './styles/ToggleLabel';
import { ToggleCheckbox } from './styles/ToggleCheckbox';
import classNames from 'classnames';

const ToggleSwitch= (props) => {
  const isActive = props.active;
  const toggleClass = classNames({
    'toggle-switch': true,
    'active-toggle-switch': isActive,
  });
  return (
    <ToggleBox>
      <ToggleLabel>{props.label}</ToggleLabel>
      <ToggleCheckbox>
        <input type="checkbox" />
        <span className={toggleClass} onClick={props.onClick}></span>
      </ToggleCheckbox>
    </ToggleBox>
  )
};

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/ToggleSwitch.jsx